export const getConstraints = (isMac, cameraType) => {
    return isMac ?
        {
            audio: false,
            video: {
                facingMode: cameraType,
                width: 1280,
                height: 720
            }
        } : {
            audio: false,
            video: {
                facingMode: cameraType,
                width: { ideal: 1928 }, // 1920
                height: { ideal: 1080 }, // 1080
                focusMode: 'continuous'
            }
        };
};
